import React from "react";
import { Container, Circle, InnerGround, Display } from "./styles";

const CircularProgressBar = ({ productivity = 20 }) => {
  const frameCount = 120;

  return (
    <Container>
      <Circle frameCount={frameCount} productivity={productivity}>
        <InnerGround>
          <Display productivity={productivity}>{productivity}%</Display>
        </InnerGround>
      </Circle>
    </Container>
  );
};

export default CircularProgressBar;
